<template>
  <div class="sino-activityType-container">
    <div
      class="activityType-item"
      v-for="item in signGroupList"
      :key="item.signGroupId"
      @click="openActivityDetail(item)"
    >
      {{item.signGroupName}}
      <span v-if="item.state == '已打卡'">
        <i class="el-icon-check"></i>
        <b>已签到</b>
      </span>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { getSignGroup } from "@/common/api";
import { toast } from "@/common/api/api.js";
export default {
  name: "activityType",
  data() {
    return {
      signGroupList: []
    };
  },
  created() {
    this.getSignGroupList();
  },
  methods: {
    getSignGroupList() {
      getSignGroup({
        id: this.$route.query.id
      }).then(res => {
        if (res.code == 200) {
          this.signGroupList = res.data;
        }
      });
    },
    openActivityDetail(item) {
      this.$router.push({
        path: "/directActivity",
        query: {
          id: this.$route.query.id,
          status: this.$route.query.status,
          signGroupId: item.signGroupId
        }
      });
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === "personalCenter") {
      next({name: "activity" });
    } else {
      next();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.sino-activityType-container {
  height: 95vh;
  padding: 0.4rem;

  .activityType-item:nth-of-type(odd) {
    margin-right: 0.4rem;
  }

  .activityType-item {
    display: inline-block;
    width: 164px;
    height: 73px;
    line-height: 73px;
    text-align: center;
    font-size: 18px;
    color: rgba(146, 156, 175, 1);
    background: #ffffff;
    margin: 0 0 0.4rem 0;
    padding: 0 .2rem;
    position: relative;
    vertical-align:top;
    overflow : hidden;
    white-space : nowrap;
    text-overflow:ellipsis;
    box-sizing: border-box;
    span {
      display: inline-block;
      width: 62px;
      height: 18px;
      line-height: 18px;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      position: absolute;
      bottom: 5px;
      right: 1px;
      text-align: right;
      padding-right: 0.08rem;
      background: rgba(56, 199, 196, 1);
      border-radius: 16px 0px 0px 16px;
      i {
        padding-right: .2rem;
      }
    }
  }
}
</style>